import styled, {css} from 'styled-components'
import {Modal, ModalBody} from '@/components/ui/modal-atoms/ModalAtoms.tsx'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledExportsModal = styled(Modal)(
    ({theme: {spacing}}) => css`
        top: ${spacing * 5}px;
        bottom: ${spacing * 5}px;
        right: ${spacing * 5}px;
        left: unset;
        transform: unset;
        display: grid;
        grid-template-rows: auto minmax(0, 1fr);
        max-height: unset;
    `
)

export const StyledExportsModalHeader = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        background-color: ${palette.neutral[50]};
        padding: ${spacing * 4}px;
        border-bottom: 1px solid ${palette.neutral[200]};
    `
)

export const StyledExportsModalBody = styled(ModalBody)(
    () => css`
        padding: 0;
        overflow: auto;
        min-height: 0;
    `
)
